import gql from 'graphql-tag';
import { virtualPabxOperatingScheduleFragment } from './fragments';

export const configureSipAccount = gql`
  mutation configureSipAccount(
    $deviceId: Int!
    $condominiumId: Int!
    $typeSip: Int!
  ) {
    configureSipAccount(
      deviceId: $deviceId
      condominiumId: $condominiumId
      typeSip: $typeSip
    )
  }
`;

export const configureAta = gql`
  mutation configureAta($condominiumId: Int!, $typeSip: Int!) {
    configureAta(condominiumId: $condominiumId, typeSip: $typeSip)
  }
`;

export const resyncSipAccount = gql`
  mutation resyncSipAccount($sipAccountConfigurationId: Int!) {
    resyncSipAccount(sipAccountConfigurationId: $sipAccountConfigurationId)
  }
`;

export const removeSipAccount = gql`
  mutation removeSipAccount($sipAccountConfigurationId: Int!) {
    removeSipAccount(sipAccountConfigurationId: $sipAccountConfigurationId)
  }
`;

export const updateVirtualPabxConfiguration = gql`
  mutation updateVirtualPabxConfiguration(
    $virtualPabxId: Int!
    $input: VirtualPabxConfigurationInput!
  ) {
    updateVirtualPabxConfiguration(virtualPabxId: $virtualPabxId, input: $input)
  }
`;

export const saveVirtualPabxOperatingSchedules = gql`
  mutation saveVirtualPabxOperatingSchedules(
    $virtualPabxId: Int!
    $schedules: [VirtualPabxOperatingScheduleInput!]!
  ) {
    saveVirtualPabxOperatingSchedules(
      virtualPabxId: $virtualPabxId
      schedules: $schedules
    ) {
      ...virtualPabxOperatingScheduleParts
    }
  }
  ${virtualPabxOperatingScheduleFragment}
`;
